import { combineReducers } from '@reduxjs/toolkit';
import { fork } from 'redux-saga/effects';

import userAuth, { userAuthSaga } from './ducks/userAuth';
import userSettings from './ducks/userSettings';
import franchiseSettings from './ducks/franchiseSettings';
import requestApiError from './ducks/requestApiError';
import { paginationSlice } from './slices/paginationSlice';
import { meSlice } from './slices/meSlice';
import { inspectionsSlice } from './slices/inspectionsSlice';
import { filterSlice } from './slices/filterSlice';
import { wikiSlice } from './slices/wikiSlice';
import { clientSlice } from './slices/clientSlice';
import { generalSlice } from './slices/generalSlice';
import { projectSlice } from './slices/projectSlice';
import { documentsSlice } from './slices/documentsSlice';
import { allActivitiesSlice } from './slices/allActivitiesSlice';
import { conditionsSlice } from './slices/conditionsSlice';
import { clientActivitiesSlice } from './slices/clientActivitiesSlice';
import { feesSlice } from './slices/feesSlice';
import { ticketsSlice } from './slices/ticketsSlice';
import { employeeActivitiesSlice } from './slices/employeeActivitySlice';
import { globalSearchSlice } from './slices/globalSearch';
import { dashboardSlice } from './slices/dashboardSlice';
import { inspectionsReportSlice } from './slices/InspectionsReportSlice';
import { apiSlice } from './rtkQuery/apiSlice';
import { wikiKeysSlice } from './slices/wikiKeysSlice';
import { thresholdFormsSlice } from './slices/thresholdFormSlice';
import { bulkSlice } from './slices/bulkSlice';

const rootReducer = combineReducers({
  allActivities: allActivitiesSlice.reducer,
  bulkSlice: bulkSlice.reducer,
  client: clientSlice.reducer,
  clientActivities: clientActivitiesSlice.reducer,
  conditions: conditionsSlice.reducer,
  dashboard: dashboardSlice.reducer,
  documents: documentsSlice.reducer,
  employeeActivities: employeeActivitiesSlice.reducer,
  fees: feesSlice.reducer,
  filters: filterSlice.reducer,
  franchiseSettings,
  general: generalSlice.reducer,
  globalSearch: globalSearchSlice.reducer,
  inspections: inspectionsSlice.reducer,
  inspectionReports: inspectionsReportSlice.reducer,
  me: meSlice.reducer,
  pagination: paginationSlice.reducer,
  projectsSlice: projectSlice.reducer,
  requestApiError,
  tickets: ticketsSlice.reducer,
  thresholdForms: thresholdFormsSlice.reducer,
  userAuth,
  userSettings,
  wikiSlice: wikiSlice.reducer,
  wikiKeysSlice: wikiKeysSlice.reducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export function* rootSaga() {
  yield fork(userAuthSaga);
}

export default rootReducer;
